import { ReactNode } from 'react';

export interface SectionIntroProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  className?: string;
  children?: ReactNode;
}

export function SectionIntro({
  title,
  subtitle,
  className = '',
  children,
}: Readonly<SectionIntroProps>) {
  return (
    <div className={`text-container flex flex-col items-center ${className}`}>
      <h1 className="text-6xl font-bold mb-6 text-center">{title}</h1>

      {subtitle && <span className="text-xl text-center">{subtitle}</span>}

      {children}
    </div>
  );
}
